module.exports = __webpack_public_path__ + "fepro/img/ruleTitle.7b862b54.png";